import { Component, OnInit } from '@angular/core';
import { VenueServiceeService } from './services/venue-service/venue-servicee.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'My App';
  hash:string;
  spinner:string = `
    <img src="assets/imgs/Ripple-1s-200px.svg" />
  `;


  constructor(private venue:VenueServiceeService, private router:ActivatedRoute){
  }

  ngOnInit(){  
    
  }
  
}
